/**
 * Utilities for merging AI/voice-suggested tags with existing item tags.
 * Case-insensitive dedupe; existing tags always come first, in their
 * original order, followed by any genuinely new incoming tags.
 */

export const mergeTagList = (existing = [], incoming = []) => {
  const merged = existing.map((t) => String(t).trim()).filter(Boolean);
  const seen = new Set(merged.map((t) => t.toLowerCase()));
  incoming.forEach((tag) => {
    const clean = String(tag).trim();
    const key = clean.toLowerCase();
    if (clean && !seen.has(key)) {
      seen.add(key);
      merged.push(clean);
    }
  });
  return merged;
};

export const mergeTagsString = (existingCsv = '', incoming = []) =>
  mergeTagList(
    String(existingCsv)
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean),
    incoming
  ).join(', ');
